export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.directive('wp-content', {
        mounted(el: HTMLElement) {
            const images = el.querySelectorAll('img')
            if (!images) return

            images.forEach((img: HTMLImageElement) => {
                img.loading = "lazy"
            })
        }
    })
})